import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { HTTP } from "../../api/resources";
import UnsavedModal from "../Helpers/Modal/UnsavedModal";
import TemplateVariableCard from "../Templates/TemplateVariableCard";
import {
  useVariable,
  useTitleVariable,
  getOwnerType,
  getBeneficiaryFields,
  getDonorFields,
  detectTemplateVariables,
  detectTitleVariables
} from "../Helpers/Functions/Templates";
import TemplateFormInfoModal from "../Helpers/Modal/InfoModals/TemplateFormInfoModal";

export default function TemplateForm(props) {

  const [template, setTemplate] = useState(props.template);
  const [saving, setSaving] = useState(false);
  const [isDirty, setDirty] = useState(false);
  const [isNotSaved, setNotSaved] = useState(false);
  const [templateVariable, setTemplateVariable] = useState(false)
  const [senderVariable, setSenderVariable] = useState([])
  const [receiverVariable, setReceiverVariable] = useState([])
  const [donorFields, setDonorFields] = useState([])
  const [beneficiaryFields, setBeneficiaryFields] = useState([])
  const [organizationVariable, setOrganizationVariable] = useState(['name'])
  const [totalVariables, setTotalVariables] = useState([])
  const [templateOwnerType, setTemplateOwnerType] = useState('')
  const [titleVariables, setTitleVariables] = useState(false)
  const current_user = props.current_user

  useEffect(() => {
    detectTitleVariables(template, setTitleVariables)
    detectTemplateVariables(template, setTemplateVariable)
    clearVariables()
    getOwnerType(setTemplateOwnerType, current_user)
    arrangeVariables()
  }, [template])

  // method for displaying the right variables based on post owner type
  const arrangeVariables = () => {
    getDonorFields(current_user, donorFields)
    getBeneficiaryFields(current_user, beneficiaryFields)
      setReceiverVariable(['first_name', 'last_name', 'email', 'username', 'birthday', 'bio'])
      setSenderVariable(['first_name', 'last_name', 'email', 'username', 'birthday', 'bio'])
  }

  const clearVariables = () => {
    setDonorFields([])
    setBeneficiaryFields([])
    setReceiverVariable([])
    setSenderVariable([])
    setTotalVariables([])
  }

  window.onbeforeunload = (event) => {
    if (isDirty == true) {
         return ""
    }
  }

  const handleSave = async () => {
    setSaving(true)
    setDirty(false)

    let data = { template: template }

    if (template.id) {
      try {
        await updateTemplate(data);
        Alert.show("notice", "Template updated successfully")
      } catch {
        Alert.show("error", "Could not save. Try again or refresh.")
        setSaving(false);
        return;
      }
    } else {
      try {
        await saveNewTemplate(data);
        Alert.show("notice", "Template saved");
      } catch {
        Alert.show("error", "Could not save. Try again or refresh.")
        setSaving(false);
        return;
      }
    }
    setSaving(false);
    setTimeout(() => {
      window.location = `/templates/${current_user.id}`
    }, 1500)
  }

  const saveNewTemplate = async (data) => {
    return HTTP.post(`/templates/create/${0}.json`, data)
  }

  const updateTemplate = async (data) => {
    return HTTP.patch(`/templates/edit/${template.id}.json`, data)
  }

  const cancelFunction = () => {
    if (isDirty) {
      setNotSaved(true)
    } else {
      setNotSaved(false)
      window.location = `/templates/${current_user.id}`
    }
  }

  const proceed = () => {
    setNotSaved(false)
    window.location = `/templates/${0}`
  }

  const cancel = () => {
    setNotSaved(false)
  }

  useEffect(() => {}, [isDirty])


  return (
    <React.Fragment>
    <div class={templateVariable || titleVariables ? "override-container-style" : ""}>
      <div className="card overide-con-style">
        <div className="card-header flex-header">
          <h4 className="card-title">
            { template.title || 'New Template'}
          </h4>

          <div>
            <a href="#" className="btn btn-outline-danger mr-1" onClick={cancelFunction}>
              Cancel
            </a>

            <div className="btn-group">
              <button onClick={handleSave}
                name="button"
                className="btn btn-primary"
                type="button">
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                Save
              </button>
            </div>
          </div>
        </div>
        <div className="card-body">
            <TemplateFormInfoModal />
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="title">Title</label>
                <input className="form-control" placeholder="New Template" type="text" name="title" id="title"
                  value={template.title}
                  onChange={e => {
                    const val = e.target.value;
                    setTemplate(template => {
                      return { ...template, title: val }
                    });
                    setDirty(true)
                  }}
                />

                {titleVariables && (current_user.user_type == "manager" || current_user.user_type == 'assistant_manager' ||
                current_user.user_type == "project_manager" || current_user.user_type == 'project_coordinator') &&
                  <TemplateVariableCard post={template} current_user={current_user} senderVariables={senderVariable}
                  receiverVariables={receiverVariable} organizationVariable={organizationVariable}
                  useVariable={(value) => useTitleVariable(value, template, setTemplate, setTitleVariables)} realign={true}
                  />
                }
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <label htmlFor="body">Content</label>
                <textarea className="form-control textarea" name="content" id="content"
                  value={template.content}
                  onChange={e => {
                    const val = e.target.value;
                    setTemplate(template => {
                      setDirty(true)
                      return { ...template, content: val }
                    });
                  }}
                ></textarea>

                {templateVariable && (current_user.user_type == "manager" || current_user.user_type == 'assistant_manager' ||
                current_user.user_type == "project_manager" || current_user.user_type == 'project_coordinator') &&
                  <TemplateVariableCard post={template} current_user={current_user} senderVariables={senderVariable}
                  receiverVariables={receiverVariable} organizationVariable={organizationVariable}
                  useVariable={(value) => useVariable(value, template, setTemplate, setTemplateVariable)} realign={true}
                  />
                }
              </div>
            </div>
          </div>
        </div>
      </div>

      {isNotSaved && <UnsavedModal message="You have not saved your template, are you sure you want to navigate away?" boldMessage="Click proceed to continue or cancel to remain on this page" proceed={proceed} cancel={cancel}/>}
      </div>
    </React.Fragment>
  );
}

TemplateForm.propTypes = {
  template: PropTypes.object
};
